import { useState, useEffect, useRef } from "react";
import { Form, Input, InputNumber, DatePicker, Card, Row, Col, Button, Divider, Typography, Space, Select, message, } from "antd";
import {
  FileTextOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  TeamOutlined,
  BankOutlined,
  CalendarOutlined,
  SaveOutlined,
  ClearOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { getAllProyectoByid, postProyectoFormato } from "../../../../services/sostenibilidad/formatos/sostenibilidadFormatos";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";


const { Title, Text } = Typography;

// ─── Cabecera institucional ────────────────────────────────────────────────────
function HeaderInstitucional() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "stretch",
        border: "1.5px solid #1a2535",
        borderRadius: 8,
        overflow: "hidden",
        marginBottom: 28,
        background: "#fff",
        boxShadow: "0 2px 10px rgba(53,95,145,0.10)",
      }}
    >
      {/* Logo */}
      <div
        style={{
          width: 130,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1.5px solid #1a2535",
          padding: "10px 14px",
          background: "#e8f0f9",
        }}
      >
        <Text strong style={{ color: "#355F91", fontSize: 13, textAlign: "center" }}>
          ARN
        </Text>
      </div>

      {/* Título central */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1.5px solid #1a2535",
          padding: "10px 20px",
        }}
      >
        <Title level={5} style={{ margin: 0, textAlign: "center", color: "#1a2535", fontSize: 13 }}>
          ACTA DE INICIO DE ASISTENCIA TÉCNICA PARA PROYECTOS PRODUCTIVOS
        </Title>
      </div>

      {/* Código / Fecha / Versión */}
      <div style={{ width: 160, display: "flex", flexDirection: "column" }}>
        <div style={{ borderBottom: "1px solid #1a2535", padding: "6px 10px", display: "flex", gap: 4 }}>
          <Text strong style={{ fontSize: 10 }}>CÓDIGO:</Text>
          <Text style={{ fontSize: 10 }}>IR-F-125</Text>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <div style={{ flex: 1, borderRight: "1px solid #1a2535", padding: "6px 8px" }}>
            <div><Text strong style={{ fontSize: 9 }}>FECHA:</Text></div>
            <Text style={{ fontSize: 9 }}>2021-08-10</Text>
          </div>
          <div style={{ flex: 1, padding: "6px 8px" }}>
            <div><Text strong style={{ fontSize: 9 }}>VERSIÓN:</Text></div>
            <Text style={{ fontSize: 9 }}>V-1</Text>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Tarjeta de sección ────────────────────────────────────────────────────────
function SectionCard({ icon, number, title, children }) {
  return (
    <Card
      style={{
        marginBottom: 20,
        borderRadius: 10,
        border: "1.5px solid #c8d8ec",
        boxShadow: "0 2px 8px rgba(53,95,145,0.06)",
      }}
      styles={{ body: { padding: "20px 24px" } }}
      title={
        <Space>
          <div
            style={{
              background: "#355F91",
              color: "#fff",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: 700,
              flexShrink: 0,
            }}
          >
            {number}
          </div>
          {icon}
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1a2535", textTransform: "uppercase", letterSpacing: "0.04em" }}>
            {title}
          </span>
        </Space>
      }
      headStyle={{
        background: "linear-gradient(135deg, #e8f0f9 0%, #f4f7fb 100%)",
        borderBottom: "1.5px solid #c8d8ec",
        minHeight: 48,
      }}
    >
      {children}
    </Card>
  );
}

// ─── Formulario principal ──────────────────────────────────────────────────────
export default function FormActaInicio({ proyectoId, tipoFormatoID, onClose, updateDataLocal }) {
  const [form] = Form.useForm();
  const [loading, setLoading]     = useState(true);
  const usernameFromState = useSelector((state) => state.auth.user);

  const meses = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];
  

useEffect(() => {
  // 🔥 No ejecutar si aún no existen los valores
  if (!proyectoId || !tipoFormatoID) return;

  const fetchProyecto = async () => {
    try {
      setLoading(true);

      const response = await getAllProyectoByid(
        proyectoId,
        tipoFormatoID
      );

      if (response?.success) {

        const data = response.data || {};
        form.setFieldsValue({
            ...data,

    // 🔥 Convertir fechas explícitamente
    fecha: data.fecha ? dayjs(data.fecha) : dayjs(),
    fecha_nombramiento: data.fecha_nombramiento
      ? dayjs(data.fecha_nombramiento)
      : null,
    fecha_posesion: data.fecha_posesion
      ? dayjs(data.fecha_posesion)
      : null,

    nombre_organizacion:
      "Organización de las Naciones Unidas para la Alimentación y la Agricultura_FAO_Colombia",
  });

        message.success("Datos cargados correctamente");

      } else {
        form.setFieldsValue({});
        onClose();
         message.error("Ocurrió un error al obtener los datos");
      }

    } catch (error) {
      console.error("Error cargando proyecto:", error);
      form.setFieldsValue({});
      onClose();
      message.error("Ocurrió un error al obtener los datos");

    } finally {
      setLoading(false);
    }
  };

  fetchProyecto();

}, [proyectoId, tipoFormatoID]);

  // Extrae dia/mes/vigencia del DatePicker 
  const buildPayload = (values) => ({
    ...values,
    dia:      values.fecha ? values.fecha.date()      : undefined,
    mes:      values.fecha ? values.fecha.month() + 1 : undefined,
    vigencia: values.fecha ? values.fecha.year()      : undefined,
  });

  // Submit final (botón Guardar)
// Submit final (botón Guardar)
const handleFinish = async (values) => {
  try {
    const payload = buildPayload(values);

    const data = {
      oidTipoFormato: tipoFormatoID,
      data: payload,
      usuario: usernameFromState.username,
    };

    const response = await postProyectoFormato(proyectoId, data);

    if (response?.success) {
      message.success(response.message || "Guardado correctamente");
      updateDataLocal(proyectoId, tipoFormatoID)
      onClose();
    } else {
      message.error(response?.message || "Ocurrió un error al guardar");
    }

  }  catch (error) {
     message.error("Error al cargar datos");
}
};


  const inputNumberProps = {
    style: { width: "100%" },
    formatter: (v) => (v ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : ""),
    parser: (v) => (v ? v.replace(/\$\s?|(\.*)/g, "") : ""),
    min: 0,
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #e8f0f9 0%, #f4f7fb 60%, #eaf3ef 100%)",
        padding: "32px 16px",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div style={{ maxWidth: 900, margin: "0 auto" }}>

        <HeaderInstitucional />

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          requiredMark="optional"
          size="middle"
        >

          {/* ── Fecha, ciudad y código ─────────────────────────── */}
          <Card
            style={{ marginBottom: 20, borderRadius: 10, border: "1.5px solid #c8d8ec", boxShadow: "0 2px 8px rgba(53,95,145,0.06)" }}
            styles={{ body: { padding: "16px 24px" } }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  label={
                    <Space>
                      <CalendarOutlined style={{ color: "#355F91" }} />
                      <Text strong>Fecha del acta</Text>
                    </Space>
                  }
                  name="fecha"
                  rules={[{ required: true, message: "Ingresa la fecha del acta" }]}
                  style={{ marginBottom: 0 }}
                >
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" placeholder="DD/MM/AAAA" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* ── Sección 1: Identificación del proyecto ─────────── */}
          <SectionCard
            number="1"
            icon={<FileTextOutlined style={{ color: "#355F91" }} />}
            title="Identificación del Proyecto Productivo"
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Nombre del proyecto productivo"
                  name="nombre_proyecto"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input disabled placeholder="Nombre completo del proyecto" />
                </Form.Item>
              </Col>
              
              <Col xs={24} sm={12}>
                <Form.Item label="Nombre de la forma Asociativa" name="organizacion" rules={[{ required: true, message: "Requerido" }]}>
                  <Input disabled placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label="Dependencia de la ARN (Grupo Territorial)"
                  name="grupo_territorial"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input disabled placeholder="Nombre del grupo territorial" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Código del proyecto PRE-PP" name="codigo_pre" rules={[{ required: true, message: "Requerido" }]}>
                  <Input disabled placeholder="Código PRE-PP" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="N.º personas en reincorporación vinculadas"
                  name="total_participantes"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <InputNumber  style={{ width: "100%" }} min={1} placeholder="0" />
                </Form.Item>
              </Col>

            </Row>
          </SectionCard>

          {/* ── Sección 2: Ubicación del proyecto ──────────────── */}

          <SectionCard
            number="2"
            icon={<DollarOutlined style={{ color: "#355F91" }} />}
            title=" Ubicación del proyecto"
          >

            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Departamento"
                  name="departamento"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Departamento del proyecto" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Municipio"
                  name="municipio"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Municipio del proyecto" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item label="Vereda / Dirección" name="ubicacion_proyecto" rules={[{ required: true, message: "Requerido" }]}>
                  <Input placeholder="Vereda o dirección del proyecto" />
                </Form.Item>
              </Col>

            <Col xs={24} sm={12}>
                <Form.Item label="Acompañamiento  y asistencia técnica por" name="nombre_organizacion" rules={[{ required: true, message: "Requerido" }]}>
                  <TextArea placeholder="Nombre de la organización" />
                </Form.Item>
              </Col>
            </Row>
         </SectionCard>

          {/* ── Sección 3: Información financiera ──────────────── */}
          <SectionCard
            number="3"
            icon={<DollarOutlined style={{ color: "#355F91" }} />}
            title="Información Financiera del Proyecto Productivo"
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Form.Item label="Valor del total del proyecto" name="valor_total_proyecto" rules={[{ required: true, message: "Requerido" }]}>
                  <InputNumber {...inputNumberProps} placeholder="$ 0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Valor del apoyo económico de reincorporación"
                  name="valor_apoyo_economico_reincorporacion"
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <InputNumber {...inputNumberProps} placeholder="$ 0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item 
                    label="Valor de los aportes propios" 
                    name="valor_aportes_propios"
                    rules={[{ required: true, message: "Requerido" }]}>
                  <InputNumber {...inputNumberProps} placeholder="$ 0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="Valor cierre financiero (Si aplica)" name="valor_cierre_financiero">
                  <InputNumber {...inputNumberProps} placeholder="$ 0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="Valor otros aportes (Si aplica)" name="valor_otros_aportes">
                  <InputNumber {...inputNumberProps} placeholder="$ 0" />
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>

            <Row gutter={[16, 0]}>
              <Col xs={24} sm={24}>
                <Form.Item label="Objetivo general del proyecto:" name="objetivo_proyecto" rules={[{ required: true, message: "Requerido" }]}>
                  <TextArea placeholder="Descripción del objetivo" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24}>
                <Form.Item label="Descripción del proyecto" name="descripcion_proyecto" rules={[{ required: true, message: "Requerido" }]}>
                  <TextArea placeholder="Descripción del proyecto de manera resumida" />
                </Form.Item>
              </Col>
            </Row>

          {/* ── Sección 4: Datos de la organización ────────────── */}
          <SectionCard
            number="4"
            icon={<BankOutlined style={{ color: "#355F91" }} />}
            title="Datos de la Organización (Proyectos Colectivos)"
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={16}>
                <Form.Item label="Nombre de la organización – Sigla" name="name_organizacion_sigla">
                  <TextArea disabled placeholder="Nombre completo y sigla" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="NIT de la organización" name="nit_organizacion">
                  <Input placeholder="Registrar número de NIT de la organización" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item label="Representante legal" name="representante_legal_organizacion">
                  <Input placeholder="Nombre del representante legal de la organización" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Cédula del representante legal"
                  name="cedula_representante_legal_organizacion"
                >
                  <Input type="number" placeholder="Número de cédula" />
                </Form.Item>
              </Col>


                    {/* Tipo de nombramiento */}
                    <Col xs={24} sm={12}>
    <Form.Item
      label="Nombrado mediante"
      name="tipo_nombramiento"
      rules={[{ required: true, message: "Selecciona el tipo" }]}
    >
      <Select 
      placeholder="Selecciona el tipo"
       onChange={() => {
        form.setFieldsValue({
          numero_nombramiento: undefined,
          fecha_nombramiento: undefined,
          fecha_posesion: undefined,
          otro_tipo_nombramiento: undefined,
        });
      }}
       >
        <Select.Option value="Decreto">Decreto</Select.Option>
        <Select.Option value="Nombramiento">Nombramiento</Select.Option>
        <Select.Option value="Elección popular">Elección popular</Select.Option>
        <Select.Option value="Acta">Acta</Select.Option>
        <Select.Option value="Otro">Otro</Select.Option>
        <Select.Option value="No aplica">No aplica</Select.Option>
      </Select>
    </Form.Item>
                    </Col>

                    {/* Campos dinámicos */}
                    <Form.Item
    noStyle
    shouldUpdate={(prev, curr) =>
      prev.tipo_nombramiento !== curr.tipo_nombramiento
    }
  >
    {({ getFieldValue }) => {
      const tipo = getFieldValue("tipo_nombramiento");

      if (!tipo || tipo === "No aplica") return null;

      return (
        <>
          {/* Solo si es "Otro" */}
          {tipo === "Otro" && (
            <Col xs={24} sm={12}>
              <Form.Item
                label="Especifique"
                name="otro_tipo_nombramiento"
                rules={[{ required: true, message: "Especifica el tipo" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          )}

          {/* Número */}
          <Col xs={24} sm={12}>
            <Form.Item
              label="Número del documento"
              name="numero_nombramiento"
              rules={[{ required: true, message: "Ingresa el número" }]}
            >
              <Input placeholder="Ej: 0456-2024" />
            </Form.Item>
          </Col>

          {/* Fecha nombramiento */}
          <Col xs={24} sm={12}>
            <Form.Item
              label="Fecha del nombramiento"
              name="fecha_nombramiento"
              rules={[{ required: true, message: "Selecciona la fecha" }]}
            >
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
          </Col>

          {/* Fecha posesión */}
          <Col xs={24} sm={12}>
            <Form.Item
              label="Fecha de posesión"
              name="fecha_posesion"
            >
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
        </>
      );
    }}
                    </Form.Item>
        
             <Col xs={24} sm={16}>
                <Form.Item label="Nombre del Coordinador del Grupo Territorial y/o delegado" name="nombre_coordinador_grupo_territorial">
                  <TextArea placeholder="Escribir el nombre del Coordinador del Grupo Territorial y/o delegado" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="Grupo territorial" name="grupo_territorial">
                  <TextArea disabled placeholder="Grupo territorial" />
                </Form.Item>
              </Col>
              
            </Row>
          </SectionCard>

          {/* ── Sección 5: Datos ARN ────────────────────────────── */}
          <SectionCard
            number="5"
            icon={<TeamOutlined style={{ color: "#355F91" }} />}
            title="Adicione los comités e integrantes que requiera el proyecto"
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={24}>
               <Form.List name="comites">
  {(fields, { add, remove }) => (
    <>
      {fields.map((field, index) => (
        <Card
          key={field.key}
          style={{
            marginBottom: 24,
            borderRadius: 12,
          }}
          bodyStyle={{ padding: 20 }}
        >
          {/* Header del Comité */}
          <Row justify="space-between" align="middle">
            <Col>
              <h3 style={{ margin: 0 }}>
                📌 Comité {index + 1}
              </h3>
            </Col>
            <Col>
              <Button
                danger
                type="text"
                onClick={() => remove(field.name)}
              >
                Eliminar Comité
              </Button>
            </Col>
          </Row>

          <Divider />

          {/* Nombre del comité */}
          <Form.Item
            label="Nombre del Comité"
            name={[field.name, "nombre_comite"]}
            rules={[{ required: true, message: "Ingresa el nombre del comité" }]}
          >
            <Input size="large" placeholder="Ej: Comité de Seguimiento" />
          </Form.Item>

          {/* Personas */}
          <Card
            size="small"
            title="👥 Integrantes del Comité"
            style={{ background: "#fafafa", borderRadius: 8 }}
          >
            <Form.List name={[field.name, "personas"]}>
              {(subFields, { add: addPerson, remove: removePerson }) => (
                <>
                  {subFields.map((subField, subIndex) => (
                    <Row
                      gutter={16}
                      key={subField.key}
                      align="middle"
                      style={{
                        padding: 12,
                        background: "#fff",
                        marginBottom: 8,
                        borderRadius: 8,
                        border: "1px solid #f0f0f0",
                      }}
                    >
                      <Col xs={24} sm={10}>
                        <Form.Item
                          label="Nombre"
                          name={[subField.name, "nombre"]}
                          rules={[{ required: true }]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input placeholder="Nombre completo" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={10}>
                        <Form.Item
                          label="Cédula"
                          name={[subField.name, "cedula"]}
                          rules={[{ required: true }]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input placeholder="Número de cédula" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={4} style={{ textAlign: "right" }}>
                        <Button
                          danger
                          type="link"
                          onClick={() => removePerson(subField.name)}
                        >
                          Eliminar
                        </Button>
                      </Col>
                    </Row>
                  ))}

                  <Button
                    type="dashed"
                    onClick={() => addPerson()}
                    icon={<PlusOutlined />}
                    style={{ marginTop: 10 }}
                    block
                  >
                    Agregar integrante
                  </Button>
                </>
              )}
            </Form.List>
          </Card>
        </Card>
      ))}

      <Button
        type="primary"
        onClick={() => add()}
        icon={<PlusOutlined />}
        size="large"
        block
      >
        Agregar Nuevo Comité
      </Button>
    </>
  )}
</Form.List>
              </Col>

            </Row>
          </SectionCard>



          {/* ── Sección 6: FIRMA DEL ACTA DE INICIO──────────────── */}
          <SectionCard
            number="6"
            icon={<DollarOutlined style={{ color: "#355F91" }} />}
            title="Firma del acta de inicio"
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={5}>
                 <Form.Item
    label="Selecciona el día"
    name="dia_firma"
    rules={[{ required: true, message: "Requerido" }]}
  >
    <Select placeholder="Día">
      {Array.from({ length: 31 }, (_, i) => (
        <Select.Option key={i + 1} value={i + 1}>
          {i + 1}
        </Select.Option>
      ))}
    </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={5}>
  <Form.Item
    label="Selecciona el mes"
    name="mes_firma"
    rules={[{ required: true, message: "Requerido" }]}
  >
    <Select placeholder="Mes">
      {meses.map((mes) => (
        <Select.Option key={mes.value} value={mes.label}>
          {mes.label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
              </Col>            

              <Col xs={24} sm={5}>
  <Form.Item
    label="Selecciona el año"
    name="vigencia_firma"
    rules={[{ required: true, message: "Requerido" }]}
  >
    <Select placeholder="Año">
      {Array.from({ length: 5 }, (_, i) => {
        const year = 2026 + i;
        return (
          <Select.Option key={year} value={year}>
            {year}
          </Select.Option>
        );
      })}
    </Select>
  </Form.Item>
              </Col>

               <Col xs={24} sm={9}>
                <Form.Item label="Escribe la ciudad , departamento" name="ciudad_firma" rules={[{ required: true, message: "Requerido" }]}>
                  <TextArea  />
                </Form.Item>
              </Col>
              
            </Row>
          </SectionCard>

          {/* ── Botones ──────────────────────────────────────────── */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, paddingBottom: 32 }}>
            <Button
              icon={<ClearOutlined />}
              onClick={() => form.resetFields()}
              size="large"
              style={{ borderRadius: 8 }}
            >
              Limpiar
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              size="large"
              style={{
                background: "#355F91",
                borderColor: "#355F91",
                borderRadius: 8,
                fontWeight: 600,
                paddingInline: 32,
              }}
            >
              Guardar acta
            </Button>
          </div>

        </Form>
      </div>
    </div>
  );
}